import { BitkitButton, BitkitDialog } from '@bitrise/bitkit-v2';
import { Text } from '@chakra-ui/react/text';

import AppForAppPage from '@/pages/App/types/AppForAppPage';

import useDeleteScheduledBuild from './hooks/useDeleteScheduledBuild';

type DialogProps = {
  isOpen: boolean;
  onClose: () => void;
  scheduledBuildItemId: string;
  app: AppForAppPage;
};

const DeleteScheduledBuildDialog = (props: DialogProps) => {
  const { isOpen, onClose, scheduledBuildItemId, app } = props;

  const { mutate: deleteScheduledBuild, isPending } = useDeleteScheduledBuild({
    id: scheduledBuildItemId,
    app,
  });

  const handleDelete = () => {
    deleteScheduledBuild({});
    onClose();
  };

  return (
    <BitkitDialog
      open={isOpen}
      onOpenChange={({ open }) => !open && onClose()}
      title="Delete scheduler?"
      footerButtons={
        <>
          <BitkitButton onClick={onClose} variant="secondary">
            Cancel
          </BitkitButton>
          <BitkitButton variant="danger-primary" onClick={handleDelete} state={isPending ? 'loading' : undefined}>
            Delete
          </BitkitButton>
        </>
      }
    >
      <Text>Are you sure you want to delete this scheduler?</Text>
    </BitkitDialog>
  );
};

export default DeleteScheduledBuildDialog;
